export default __webpack_public_path__ + "static/media/random.316c6c9d.jpg";